import React from 'react';
import { cn } from './cn';

// Page layout: full-height background + a sticky sub-header (sits under the
// 64px TopNav) + a centered content area. Kills the duplicated page-shell
// markup and the hard-coded top offsets scattered across pages.
const PageShell = ({ title, subtitle, icon: Icon, actions, children, headerExtra, maxWidth = 'max-w-7xl' }) => (
  <div className="min-h-screen bg-background">
    <div className="sticky top-16 z-10 border-b border-border bg-surface/80 backdrop-blur-md">
      <div className={cn(maxWidth, 'mx-auto px-4 sm:px-6 py-4')}>
        <div className="flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            {Icon && (
              <span className="grid h-10 w-10 place-items-center rounded-xl gradient-brand text-white shadow-md">
                <Icon className="h-5 w-5" />
              </span>
            )}
            <div>
              <h1 className="text-xl font-bold text-foreground leading-tight">{title}</h1>
              {subtitle && <p className="text-sm text-muted">{subtitle}</p>}
            </div>
          </div>
          {actions && <div className="flex flex-wrap items-center gap-2">{actions}</div>}
        </div>
        {headerExtra && <div className="mt-4">{headerExtra}</div>}
      </div>
    </div>
    <main className={cn(maxWidth, 'mx-auto px-4 sm:px-6 py-6 animate-fade-in')}>{children}</main>
  </div>
);

export default PageShell;
